import { checkStoreIs } from '@helpers/env'
import Translations from '@helpers/translations'
import { FormData } from '@components/returns/OrderForm'

const formData: FormData = {
  errorNotification: (
    <>
      <p>
        We didn't recognise that order number and/or postcode. Please double
        check and try again. Remember, we need your delivery postcode, not the
        one used for billing.
      </p>
      <p>
        If your order ID starts with US, please use the country selector in the
        footer to switch to the US store to access the correct returns portal.
      </p>
      <p>
        If your order ID starts with EU or DE please use the country selector to
        switch to the EU store.
      </p>
    </>
  ),
  header: {
    title: Translations.localise('pages.returns.arrange-a-return'),
    byline: [],
    image: {
      mobile:
        'https://images.ctfassets.net/amhdwl2zsv5z/7vULjyo6xlDzxpPwxOkfE3/e20945bae8387c665d27005cad0c11b5/ReturnsPortalMobileImage-min.jpg?fl=progressive',
      desktop:
        'https://images.ctfassets.net/amhdwl2zsv5z/5MVQYtDh8RQMmFDzqqdRI7/940117c6db747084626e811171d8849e/ReturnsPortalDesktopIMage-min.jpg?fl=progressive'
    }
  },
  buttonCopy: Translations.localise('pages.returns.continue'),
  content: [
    {
      id: 'order_number',
      question: Translations.localise('pages.returns.order-number'),
      type: 'text',
      required: true,
      answers: [''],
      ...(checkStoreIs('gb') && {
        inputMode: 'numeric',
        pattern: '[0-9]*'
      }),
      hidden: false
    },
    {
      id: 'postcode',
      question: Translations.localise('pages.returns.postcode'),
      type: 'text',
      required: true,
      answers: [''],
      hidden: false
    }
  ]
}

export default formData
